import Icon from 'veui/components/Icon'

Icon.register({
  clock: {
    paths: [
      {
        d: 'M24 48a24 24 0 110-48 24 24 0 010 48zm0-4a20 20 0 100-40 20 20 0 000 40zm1-20h7a2 2 0 110 4h-9a2 2 0 01-2-2V13a2 2 0 114 0v11z'
      }
    ],
    width: '48',
    height: '48'
  }
})
